import { PropsWithChildren, Suspense } from "react";
import LoadingSpinner from "@imminently/decisively-ui/LoadingSpinner";
import styled from "@emotion/styled";
import Icon from "@imminently/decisively-ui/Icon";
import LoadingOverlay from "@imminently/decisively-ui/LoadingOverlay";


const Layout = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
`;

const SuspenseFallback = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const LoadingRoute = () => (
  <SuspenseFallback>
    <LoadingOverlay   />
  </SuspenseFallback>
);

export const AsyncRoute = ({ children }: PropsWithChildren) => (
  <Suspense fallback={<LoadingRoute />}>
    {children}
  </Suspense>
);

export const AsyncLayout = ({ page }: any) => {
  return (
    <Layout>
      <AsyncRoute>
        {page}
      </AsyncRoute>
    </Layout>
  );
};